// extracted by mini-css-extract-plugin
export var button = "_es-4";
export var hasDarkBackground = "_es-7";
export var hasLightBackground = "_es-6";
export var iconWrapper = "_es-0";
export var large = "_es-2";
export var medium = "_es-1";
export var small = "_es-5";
export var xsmall = "_es-3";